<template>
<div class="project-drawer-container">
	<v-btn icon small class="toggle-button" @click="toggleMenu">
		<v-icon small color="white">mdi-expand-all-outline</v-icon>
	</v-btn>
	<v-navigation-drawer
		v-model="$store.menuStore.state.sidebarStatus"
		absolute
		temporary
		right
		app
		:width="$store.menuStore.state.sidebarStatus ? '350':'0'"
	>
		<div class="py-2 px-5 d-flex justify-end align-center" style="gap: 10px;background: #eef1fb;" v-if="!$store.menuStore.state.sidebarMini">
			<AccountSettingsModal />
			<v-icon color="#2D4B95" @click="toggleMenu">mdi-close-box</v-icon>
		</div>
		<v-divider class="mb-2"></v-divider>
		<div>
			<SearchBarHeader v-if="$vuetify.breakpoint.mobile" class="px-4"/>
			<v-divider class="mt-2 mb-2" v-if="$vuetify.breakpoint.mobile"></v-divider>
			<!-- <v-btn
				text
				color="#3EBFA3"
				class="text-capitalize px-0 my-5 justify-start"
				block
				left
				v-if="checkCompanyLevelPermissions(['edit_project'])"
				@click="() => {
					this.$store.projectsStore.commit('setNewProjectModal', true)
					this.toggleMenu()
				}"
			>
				<v-icon color="white" class="new-project-icon mr-3">mdi-plus-circle-outline</v-icon>
				Nuevo Proyecto
			</v-btn> -->

			<div class=" px-4 pb-0">
				<div class="user-row" v-if="!$store.menuStore.state.sidebarMini && !$vuetify.breakpoint.mobile && $store.userStore.state.userInfo">
					<img v-if="$store.userStore.state.userInfo.info.avatar" :src="$store.userStore.state.userInfo.info.avatar" class="user-avatar-sm"/>
					<v-icon v-else class="user-avatar-icon" color="#5E85EF">mdi-account-circle</v-icon>
					<div class="user-info">
						<p class="mb-0 user-name">{{$store.userStore.state.userInfo.name}}</p>
						<p class="mb-0 user-job" v-if="$store.projectsStore.state.selectedProject && $store.projectsStore.state.selectedProject.job_type">{{$store.projectsStore.state.selectedProject.job_type.name}}</p>
					</div>
				</div>
				<!-- Fila 2: foto proyecto + nombre + selector -->
				<ProjectSelector />

				<v-divider class="mt-2 mb-2"></v-divider>
				<v-list-item
					v-if="selectedProject"
					link
					class="interactions-entry d-flex align-center px-3 mt-2"
					@click="openInteractions"
				>
					<v-icon class="interactions-entry-icon" size="20" color="#2D4B95">mdi-message-text-multiple-outline</v-icon>
					<p class="mb-0 ml-2 interactions-entry-text body-2">Historial de Interacciones</p>
					<v-spacer></v-spacer>
					<v-icon size="18" color="#9aa7c2">mdi-chevron-right</v-icon>
				</v-list-item>
			</div>
		</div>

		<v-divider class="mt-2 mb-2"></v-divider>

		<v-expansion-panels class="sidebar-projects" flat>
			<v-expansion-panel>
				<v-expansion-panel-header>
					<p class="mb-0 sidebar-section-title">Opciones del Proyecto</p>
				</v-expansion-panel-header>
				<v-expansion-panel-content>
					<p class="mb-0 caption">Estas opciones son por proyecto, por lo que si tienes varios, procura modificarlas en cada uno</p>
					<v-checkbox
						v-model="project_options.notification_sound"
						hide-details
						class="my-0"
						label="Desactivar sonido notificaciones"
					>
						<template v-slot:label>
							<p class="mb-0 caption">Sonido notificaciones</p>
						</template>
					</v-checkbox>
					<v-btn
						class="mx-0 mt-2"
						color="#2D4B95"
						block
						dark
						small
						:loading="savingOptions"
						@click="saveOptions"
					>
						<p class="mb-0">Guardar Opciones</p>
					</v-btn>
					<v-divider class="my-3"></v-divider>
					<v-btn
						class="mx-0"
						color="#2D4B95"
						block
						dark
						small
						outlined
						@click="() => {
							this.$store.usersStore.commit('setNotificationsConfigModal', true)
							this.toggleMenu()
						}"
					>
						<p class="mb-0">Configurar Notificaciones</p>
					</v-btn>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>

		<v-divider class="mb-2"></v-divider>

		<v-expansion-panels class="sidebar-projects" flat>
			<v-expansion-panel>
				<v-expansion-panel-header>
					<p class="mb-0 sidebar-section-title">Accesos Rápidos</p>
				</v-expansion-panel-header>
				<v-expansion-panel-content>
					<v-list class="py-0" dense>
						<v-list-item link class="menu-item-inner d-flex align-center" @click="toTareas(2)">
							<v-icon class="menu-item-icon" color="#2D4B95">mdi-clipboard-text-outline</v-icon>
							<p class="mb-0 ml-2 menu-item-text body-2">Mis Tareas</p>
						</v-list-item>
						<v-list-item link class="menu-item-inner d-flex align-center" @click="toTareas(3)">
							<v-icon class="menu-item-icon" color="#2D4B95">mdi-clipboard-clock-outline</v-icon>
							<p class="mb-0 ml-2 menu-item-text body-2">Tareas Pendientes</p>
						</v-list-item>
						<v-list-item link class="menu-item-inner d-flex align-center" @click="toTareas(4)">
							<v-icon class="menu-item-icon" color="#2D4B95">mdi-clipboard-check-outline</v-icon>
							<p class="mb-0 ml-2 menu-item-text body-2">Tareas Finalizadas</p>
						</v-list-item>
						<v-list-item link class="menu-item-inner d-flex align-center" @click="toTareas(5)">
							<v-icon class="menu-item-icon" color="#2D4B95">mdi-account-clock-outline</v-icon>
							<p class="mb-0 ml-2 menu-item-text body-2">Tareas por Usuario</p>
						</v-list-item>
						<v-divider class="my-2"></v-divider>
						<v-list-item link class="menu-item-inner d-flex align-center" @click="toRDI(2)">
							<v-icon class="menu-item-icon" color="#2D4B95">mdi-file-document-outline</v-icon>
							<p class="mb-0 ml-2 menu-item-text body-2">RDI Pendientes</p>
						</v-list-item>
						<v-list-item link class="menu-item-inner d-flex align-center" @click="toRDI(3)">
							<v-icon class="menu-item-icon" color="#2D4B95">mdi-file-document-multiple-outline</v-icon>
							<p class="mb-0 ml-2 menu-item-text body-2">RDI Finalizadas</p>
						</v-list-item>
					</v-list>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>

		<v-spacer></v-spacer>

		<div v-if="canShowConfig" class="px-6 py-4 admin-config-section">
			<v-divider class="mb-4"></v-divider>
			<v-btn
				class="admin-config-btn"
				color="#2D4B95"
				block
				dark
				@click="goToAdminConfig"
			>
				<v-icon left>mdi-cog-outline</v-icon>
				<div>
					<p class="mb-0">Configuración Sistema</p>
					<p class="mb-0 caption">Administración</p>
				</div>
			</v-btn>
		</div>

		<div class="px-6 pb-4 bottom-actions-section">
			<v-divider class="mb-4"></v-divider>
			<v-btn
				class="communication-sidebar-btn mb-2"
				color="#2D4B95"
				block
				outlined
				@click="openCommunicationModal"
			>
				<v-icon left>mdi-forum-outline</v-icon>
				<span>Canal de comunicación</span>
			</v-btn>
			<v-btn
				class="complaint-sidebar-btn"
				color="#F4516C"
				block
				outlined
				@click="openComplaintModal"
			>
				<v-icon left>mdi-shield-alert-outline</v-icon>
				<span>Canal de denuncias</span>
			</v-btn>
		</div>
	</v-navigation-drawer>
	<InteractionsSidebar />
</div>
</template>

<script>
import SearchBarHeader from '@/components/Globals/Headers/SearchBarHeader'
import ProjectSelector from '@/components/Layout/Helpers/ProjectSelector'
import AccountSettingsModal from '@/components/Globals/Modals/Users/AccountSettingsModal'
import InteractionsSidebar from '@/components/Layout/ProjectSidebar/InteractionsSidebar'

export default {
	name: 'ProjectSidebarIndex',
	components: {SearchBarHeader, ProjectSelector, AccountSettingsModal, InteractionsSidebar},
	data: () => ({
		savingOptions: false,
		project_options: {
			notification_sound: true
		}
	}),
	computed: {
		selectedProject() {
			return this.$store.projectsStore.state.selectedProject
		},
		canShowConfig(){
			return this.$store.userStore.getters.isSuperAdmin
		}
	},
	watch: {
		selectedProject(project) {
			if(project){
				this.project_options = {
					notification_sound: project.useroptions ? project.useroptions.notification_sound:false
				}
			}
		}
	},
	mounted(){
	},
	methods: {
		async saveOptions(){
			this.savingOptions = true
			const data = Object.assign({},
			this.project_options,
			{project_id: this.$store.projectsStore.state.selectedProject.id})
			await this.$store.userStore.dispatch('setUserProjectOptions', data)
			this.savingOptions = false
		},
		toggleMenu(){
			const isOpen = !this.$store.menuStore.state.sidebarStatus
			this.$store.menuStore.commit('setSidebarStatus', isOpen)
			if(isOpen) this.$store.menuStore.commit('setInteractionsSidebarStatus', false)
		},
		openInteractions(){
			if(!this.selectedProject) return
			this.$store.menuStore.commit('setSidebarStatus', false)
			this.$store.menuStore.commit('setInteractionsSidebarStatus', true)
		},
		toTareas(taskType){
			this.$store.consultasStore.commit('setSelectedType', taskType)
			if(this.$route.name != 'Consultas'){
				this.$router.push({name: 'Consultas'})
			}
			else{
				const project_id = this.$store.projectsStore.state.selectedProject.id
				this.$store.consultasStore.dispatch('getMyTasks', {project_id})
			}
			this.toggleMenu()
		},
		toRDI(taskType){
			this.$store.rdiStore.commit('setSelectedType', taskType)
			if(this.$route.name != 'Rdi'){
				this.$router.push({name: 'Rdi'})
			}
			else{
				const project_id = this.$store.projectsStore.state.selectedProject.id
				this.$store.rdiStore.dispatch('getRDI', {project_id})
			}
			this.toggleMenu()
		},
		goToAdminConfig(){
			this.toggleMenu()
			if(this.$route.name != 'AdminConfig'){
				this.$router.push({name: 'AdminConfig'})
			}
		},
		openComplaintModal(){
			this.$store.globalStore.commit('setComplaintModal', true)
			this.toggleMenu()
		},
		openCommunicationModal(){
			this.$store.globalStore.commit('setCommunicationModal', true)
			this.toggleMenu()
		}
	}
};
</script>

<style scoped>
	.toggle-button{
		background: linear-gradient(135deg, #5E85EF 0%, #2D4B95 100%) !important;
		border-radius: 8px !important;
	}
	.toggle-inner-button{
		position: absolute!important;
		top: 0;
		right: 0;
	}
	.new-project-icon{
		background-color: #3EBFA3;
		padding: 4px;
		border-radius: 100%;
	}
	.sidebar-section-title{
		color: #2D4B95;
		font-weight: 600;
	}
	.sidebar-projects .v-expansion-panel::before{
		box-shadow: none;
	}
	.sidebar-projects .v-expansion-panel .v-expansion-panel-content .v-expansion-panel-content__wrap{
		padding: 0;
	}
	.menu-item-inner{
		border-radius: 6px;
		position: relative;
		transition: background-color 0.15s ease;
	}
	.menu-item-inner:hover, .menu-item-inner.active{
		background-color: #B1BCD8;
	}
	.menu-item-inner:hover{color: white;}
	.menu-item-inner:hover:before, .menu-item-inner.active:before{
		content: '';
		color: white;
		width: 5px;
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		background-color: #2D4B95;
		opacity: 1!important;
	}

	.interactions-entry{
		border-radius: 8px;
		min-height: 40px;
		background: #eef1fb;
		border: 1px solid #dbe2f7;
		position: relative;
		overflow: hidden;
		transition: background-color 0.15s ease, border-color 0.15s ease;
	}
	.interactions-entry:before{
		content: '';
		width: 3px;
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		background-color: #2D4B95;
	}
	.interactions-entry:hover{
		background-color: #e2e8fa;
		border-color: #c5d3f0;
	}
	.interactions-entry-icon{
		flex-shrink: 0;
	}
	.interactions-entry-text{
		color: #2D4B95;
		font-weight: 600;
	}
	.admin-config-section{
		margin-top: auto;
	}
	.bottom-actions-section{
		margin-top: auto;
	}
	.communication-sidebar-btn{
		border-radius: 8px !important;
		text-transform: none !important;
		letter-spacing: normal !important;
	}
	.complaint-sidebar-btn{
		border-radius: 8px !important;
		text-transform: none !important;
		letter-spacing: normal !important;
	}
	.admin-config-btn{
		border-radius: 8px !important;
		text-transform: none !important;
		letter-spacing: normal !important;
		height: auto !important;
		padding: 4px 8px !important;
	}
	.project-drawer-container{
		display: inline-flex;
		align-items: center;
	}
</style>